import { defineStore } from 'pinia';

const SESSION_KEY = 'simm_user';

export const useGeneralStore = defineStore('general', {  
  state: () => {
    const saved = sessionStorage.getItem(SESSION_KEY);
    const parsed = saved ? JSON.parse(saved) : {};
    return {
      id: parsed.id || '',
      upn: parsed.upn || '',
      role: parsed.role || '',
    };
  },
  actions: {    
    setUserData({ id, upn, role }) {
      this.id = id;
      this.upn = upn;
      this.role = role;
    }
  },
  persist: true,
});